import { ComplianceDialog } from '../../components/ComplianceDialog';

import { useMissionAccountingComplianceIssues } from './hooks/useMissionAccountingComplianceIssues.hook';

export const MissionAccountingComplianceDialog = () => (
  <ComplianceDialog
    blockingTitle="Bloquant pour la synchronisation avec Pennylane"
    id="mission-accounting-compliance"
    issues={useMissionAccountingComplianceIssues()}
    title="Conformité comptable"
  />
);
